import { styled } from "../../../../../../styles";

export const FitbitSleepCardContainer = styled("div", {
  width: "100%",
  height: "100%",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",

  variants: {
    isEmpty: {
      true: {
        opacity: 0.36,
      },
    },
  },
});

export const GraphContainer = styled("div", {
  width: "100%",
  height: "67%",

  // Empty state shrinks the graph area (matching the generic ChartCard's
  // 67%->57%) so the stats row lifts off the card's bottom margin.
  variants: {
    isEmpty: {
      true: {
        height: "57%",
      },
    },
  },
});

export const GraphLegend = styled("div", {
  width: "100%",
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-start",

  marginBottom: "2px",

  // The chart below has a fixed height (90%) and flows *after* this legend, so the legend's height
  // determines where the graph's baseline lands. The Steps/Activity cards show two legend lines
  // (two data sources), while Sleep has a single one — leaving Sleep's legend ~22px shorter and its
  // bars sitting that much higher than the neighbouring cards. Reserve the height of a two-line
  // legend (2 × 18px line-height + 4px gap) so the Sleep baseline lines up with the others.
  minHeight: "40px",
});
